import { render, staticRenderFns } from "./NodeJS.vue?vue&type=template&id=8b47c556&scoped=true&"
import script from "./NodeJS.vue?vue&type=script&lang=js&"
export * from "./NodeJS.vue?vue&type=script&lang=js&"
import style0 from "./NodeJS.vue?vue&type=style&index=0&id=8b47c556&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b47c556",
  null
  
)

export default component.exports